import { createRouter, createWebHistory } from 'vue-router';
import RenderPage from "@/views/painel/render/RenderPage.vue";
import sessionGuardian from "@/services/session.guardian";

const routes = [
  // --------- ROTAS PÚBLICAS ---------
  { path: '/pages/:id',            name: 'render-pt',   component: RenderPage },
  { path: '/en/pages/:id',         name: 'render-en',   component: RenderPage, props: { lang: 'en' } },

  { path: '/search',               name: 'SearchResults', component: () => import('@/views/sitegame/SearchResults.vue') },
  { path: '/home',                 name: 'home',        component: () => import('@/views/sitegame/HomeView.vue') },
  { path: '/en/home',              name: 'home-en',     component: () => import('@/views/sitegame/HomeView.vue'), props: { lang: 'en' } },
  { path: '/notfound',             name: 'NotFound',    component: () => import('@/views/NotFound.vue') },
  { path: '/login',                name: 'login',       component: () => import('@/views/painel/LoginView.vue') },
  { path: '/politicadeprivacidade',                    component: () => import('@/views/sitegame/page-games/PolíticaPrivacidade.vue') },
  { path: '/deletarconta',                               component: () => import('@/views/sitegame/page-games/DeletarConta.vue') },

  // --------- ROTAS GAMIFICAÇÃO ---------
  { path: '/gamificacao/home',     name: 'gamificacao-home',    component: () => import('@/views/sitegamificacao/home/HomeView.vue') },
  { path: '/gamificacao/news',     name: 'gamificacao-news',    component: () => import('@/views/sitegamificacao/news/NewsPage.vue') },
  { path: '/gamificacao/contact',  name: 'gamificacao-contact', component: () => import('@/views/sitegamificacao/ContactView.vue') },
  { path: '/gamificacao/projects', name: 'gamificacao-projects',component: () => import('@/views/sitegamificacao/ProjectsPage.vue') },

  // --------- ROTAS PAINEL/ADMIN ---------
  { path: '/painel',               name: 'painel',              component: () => import('@/views/painel/PainelView.vue'), meta: { requiresAuth: true } },
  { path: '/dashboard-analytics',  name: 'DashboardAnalytics',  component: () => import('@/views/painel/DashboardAnalytics.vue'), meta: { requiresAuth: true } },
  { path: '/newsletter-list',      name: 'NewsletterList',      component: () => import('@/views/painel/NewsletterList.vue'), meta: { requiresAuth: true } },
  { path: '/contacts-list',        name: 'ContactList',         component: () => import('@/views/painel/ContactList.vue'), meta: { requiresAuth: true } },
  { path: '/home-edit',            name: 'HomeEdit',            component: () => import('@/views/painel/HomeEditView.vue'), meta: { requiresAuth: true } },
  { path: '/projectcreate/:id',    name: 'ProjectCreate',       component: () => import('@/views/painel/ProjectsView.vue'), meta: { requiresAuth: true } },
  { path: '/gamecreate',           name: 'GameCreate',          component: () => import('@/views/painel/GamesView.vue'), meta: { requiresAuth: true } },
  { path: '/blogcreate',           name: 'BlogCreate',          component: () => import('@/views/painel/PagesView.vue'), meta: { requiresAuth: true } },

  { path: '/',                     redirect: '/home' },

  { path: '/:pathMatch(.*)*',      name: 'NotFoundCatch',       component: () => import('@/views/NotFound.vue') }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!sessionGuardian?.getToken?.();
  if (to.meta.requiresAuth && !isLoggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;
